import { useState } from 'react';
import { usePWA } from '../hooks/usePWA';

export default function InstallBanner() {
  const { installPrompt, isInstalled, isIOS, promptInstall } = usePWA();
  const [dismissed, setDismissed] = useState(false);

  if (isInstalled || dismissed) return null;
  if (!installPrompt && !isIOS) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: '#0F1F3D', borderTop: '1px solid #1E3A5F',
      padding: '14px 16px 28px', zIndex: 999,
      fontFamily: "'DM Sans', sans-serif",
      boxShadow: '0 -8px 24px rgba(0,0,0,0.3)',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{
          width: 44, height: 44, flexShrink: 0,
          background: 'linear-gradient(135deg, #2563EB, #3B82F6)',
          borderRadius: 12, display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: 22, fontWeight: 700, color: 'white'
        }}>V</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'white' }}>
            Add Vitality to your home screen
          </div>
          {isIOS ? (
            <div style={{ fontSize: 12, color: '#64748B', marginTop: 3, lineHeight: 1.5 }}>
              Tap <strong style={{ color: '#3B82F6' }}>Share</strong> then{' '}
              <strong style={{ color: '#3B82F6' }}>"Add to Home Screen"</strong> for the full app experience.
            </div>
          ) : (
            <div style={{ fontSize: 12, color: '#64748B', marginTop: 3 }}>
              Install for fast access — works offline too.
            </div>
          )}
        </div>
        <button
          onClick={() => setDismissed(true)}
          style={{
            background: 'none', border: 'none', color: '#475569',
            fontSize: 18, cursor: 'pointer', padding: 4, flexShrink: 0
          }}>✕</button>
      </div>
      {!isIOS && installPrompt && (
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <button
            onClick={promptInstall}
            style={{
              flex: 1, padding: '11px',
              background: 'linear-gradient(135deg, #1A3260, #2563EB)',
              color: 'white', border: 'none', borderRadius: 10,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
            }}>
            Install App
          </button>
          <button
            onClick={() => setDismissed(true)}
            style={{
              padding: '11px 16px',
              background: 'rgba(255,255,255,0.08)',
              color: '#94A3B8', border: 'none', borderRadius: 10,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 14, cursor: 'pointer',
            }}>
            Not now
          </button>
        </div>
      )}
    </div>
  );
}
